import React from "react";
import {
  Create,
  SimpleForm,
  TopToolbar,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
  NumberInput,
} from "react-admin";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const CountryCreate = (props) => (
  <Create title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm redirect={props.basePath} variant="outlined">
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="nationality" fullWidth />
      <NumberInput source="isoId" fullWidth />
      <ReferenceInput
        fullWidth
        reference="risk-levels"
        source="riskId"
        validate={required()}
      >
        <SelectInput />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default CountryCreate;
